<div class="flex gap-4 h-auto flex-col sm:flex-row sm:h-9 sm:items-center text-tab-menu">
  <!-- Título: tamaño automático -->
  <div class="pr-3 text-(--comp-tabs-titule) text-primary shrink-0 sm:border-r-2">
    {{ titule }}
  </div>

  <!-- Tabs con botones de scroll -->
  <div class="flex gap-3">
    @if (showLeftButton || showRightButton) {
      <button
        [disabled]="!showLeftButton"
        matMiniFab
        class="px-2 text-tab-menu"
        (click)="scrollTabs('left')"
      >
        <mat-icon>chevron_left</mat-icon>
      </button>
    }

    @if (showLeftButton || showRightButton) {
      <button
        [disabled]="!showRightButton"
        matMiniFab
        class="px-2 text-tab-menu"
        (click)="scrollTabs('right')"
      >
        <mat-icon>chevron_right</mat-icon>
      </button>
    }
  </div>
  <div
    #tabsContainer
    class="flex flex-1 gap-2 overflow-x-auto overflow-hidden!"
    style="scroll-behavior: smooth"
    (scroll)="onTabsScroll()"
  >
    @for (tabAux of tabs; track $index) {
      <div
        [matTooltip]="tabAux.descripcion"
        [matTooltipPosition]="'above'"
        class="text-(--comp-tabs-section) px-2 py-1 rounded-xl flex items-center justify-center min-w-30 max-w-50 flex-shrink-0"
        (click)="indexSelected = $index; onTabChange(tabAux)"
        [ngClass]="{
          'cursor-pointer': indexSelected != $index,
          'bg-(--comp-tabs-select)': indexSelected == $index,
        }"
      >
        <div>
          {{ (tabAux.descripcion ? tabAux.descripcion : '') | slice: 0 : 28 | translate
          }}{{ tabAux.descripcion && tabAux.descripcion.length > 28 ? '...' : '' }}
        </div>
      </div>
    }
  </div>
</div>
